<div
  [ngStyle]="badgeStyles()"
  class="inline-flex items-center justify-center rounded-full border border-(--pill-border) bg-(--pill-bg) px-2 py-1"
>
  <span class="text-pill leading-none text-(--pill-text)">
    {{ label() }}
  </span>
</div>
